import script from "./external-roles-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./external-roles-section.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__